<template>
  <v-container>
    <v-row class="mb-6 mt-4">
      <v-col class="text-center">
        <v-icon color="amber darken-2" size="48" class="mb-2">mdi-party-popper</v-icon>
        <h2 class="text-h4 font-weight-black grey--text text--darken-3">
          {{ titulo || 'Ganhadores do Sorteio' }}
        </h2>
        <p class="text-subtitle-1 grey--text mt-1">
          Confira o ranking oficial e busque pelo seu nome!
        </p>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" lg="10">
        <v-card class="elevation-4 rounded-xl overflow-hidden">
          
          <v-card-title class="grey lighten-4 py-4 px-6 border-bottom">
            <v-text-field
              v-model="pesquisa"
              prepend-inner-icon="mdi-magnify"
              label="Buscar por nome, unidade ou prêmio..."
              single-line
              hide-details
              outlined
              rounded
              dense
              background-color="white"
              color="primary"
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :headers="cabecalhos"
            :items="ganhadores"
            :search="pesquisa"
            :loading="carregando"
            :item-class="estiloLinhaPodio"
            loading-text="Preparando os resultados..."
            no-data-text="Nenhum ganhador encontrado."
            no-results-text="Nenhum resultado para a sua busca."
            :items-per-page="-1"
            hide-default-footer
            class="elevation-0 tabela-elegante"
          >
            <template v-slot:[`item.ordem`]="{ item }">
              <div class="d-flex justify-center align-center">
                <v-icon v-if="item.ordem === 1" color="#FFD700" size="28" title="1º Lugar">mdi-trophy-award</v-icon>
                <v-icon v-else-if="item.ordem === 2" color="#C0C0C0" size="26" title="2º Lugar">mdi-trophy</v-icon>
                <v-icon v-else-if="item.ordem === 3" color="#CD7F32" size="26" title="3º Lugar">mdi-trophy</v-icon>
                <v-avatar v-else color="grey lighten-3" size="32">
                  <span class="font-weight-bold grey--text text--darken-1">{{ item.ordem }}º</span>
                </v-avatar>
              </div>
            </template>

            <template v-slot:[`item.funcionario`]="{ item }">
              <span class="font-weight-bold text-subtitle-1 black--text">
                {{ item.funcionario }}
              </span>
            </template>

            <template v-slot:[`item.premio`]="{ item }">
              <span class="primary--text font-weight-medium">
                {{ item.premio }}
              </span>
            </template>

            <template v-slot:[`item.estabelecimento`]="{ item }">
              <v-icon small color="grey" class="mr-1">mdi-map-marker-outline</v-icon>
              <span class="grey--text text--darken-2">{{ item.estabelecimento }}</span>
            </template>

            <template v-slot:[`item.cupom_ganhador`]="{ item }">
              <v-chip small color="primary" outlined class="font-weight-bold">
                <v-icon left small>mdi-ticket-percent-outline</v-icon>
                {{ item.cupom_ganhador }}
              </v-chip>
            </template>

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ListaGanhadores',
  data: () => ({
    titulo: '',
    ganhadores: [],
    carregando: true,
    pesquisa: '', 
    cabecalhos: [ 
      { text: 'Posição', value: 'ordem', align: 'center', width: '100px', sortable: true },
      { text: 'Ganhador', value: 'funcionario', align: 'start' },
      { text: 'Prêmio', value: 'premio', align: 'start' },
      { text: 'Unidade', value: 'estabelecimento', align: 'start' },
      { text: 'Cupom', value: 'cupom_ganhador', align: 'center', sortable: false },
    ]
  }),
  mounted() {
    this.buscarGanhadores();
  },
  methods: {
    async buscarGanhadores() {
      this.carregando = true;

      try {
        const response = await axios.get("colaborador/dia-trabalhador/ganhadores");
        
        if (response.data.success) {
          this.titulo = response.data.data.titulo;
          this.ganhadores = response.data.data.ganhadores;
        }
      } catch (error) {
        console.error("Erro ao buscar ganhadores:", error);
      } finally {
        this.carregando = false; 
      }
    },
    estiloLinhaPodio(item) {
      if (item.ordem === 1) return 'linha-ouro';
      if (item.ordem === 2) return 'linha-prata';
      if (item.ordem === 3) return 'linha-bronze';
      return '';
    }
  }
}
</script>

<style scoped>
.linha-ouro {
  background-color: rgba(255, 215, 0, 0.05) !important;
}
.linha-ouro:hover {
  background-color: rgba(255, 215, 0, 0.1) !important;
}

.linha-prata {
  background-color: rgba(192, 192, 192, 0.1) !important;
}
.linha-prata:hover {
  background-color: rgba(192, 192, 192, 0.15) !important;
}

.linha-bronze {
  background-color: rgba(205, 127, 50, 0.05) !important;
}
.linha-bronze:hover {
  background-color: rgba(205, 127, 50, 0.1) !important;
}

.tabela-elegante ::v-deep td {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

.border-bottom {
  border-bottom: 1px solid #e0e0e0;
}
</style>